export default __webpack_public_path__ + "static/media/bitcoin-transaction-lifecycle-xsats-order.16077185.png";